import * as React from "react";

import InnerModal, {
  InnerModalProps
} from "features/common/modals/components/InnerModal";
import Modal from "features/common/modals/containers/Modal";

type Props = InnerModalProps & {
  clickToExit?: boolean;
};

export default class WarningModal extends React.PureComponent<Props> {
  render() {
    const {
      overlayLink,
      onCancelClick,
      children,
      clickToExit,
      ...innerModalProps
    } = this.props;

    return (
      <Modal
        open
        overlayLink={overlayLink}
        closeModal={onCancelClick}
        clickToExit={
          typeof clickToExit === "boolean"
            ? clickToExit
            : !!overlayLink || !!onCancelClick
        }
      >
        <InnerModal
          primaryButtonType={["carnation", "smallText"]}
          overlayLink={overlayLink}
          onCancelClick={onCancelClick}
          {...innerModalProps}
        >
          {children}
        </InnerModal>
      </Modal>
    );
  }
}
